import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { OutreachReplyAsk } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { ASK_TEXT } from './inboxGroups';
import { inboxMessages as messages } from './inboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Inbox.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "They ask for: Spotify link, Release date" (design outreach-v2 m1): the P6 `asks` of the reply. */
const ReplyAsksComponent: React.FC<{ asks: OutreachReplyAsk[] }> = ({ asks }) => {
  const intl = useIntl();
  const chips = useMemo(
    () =>
      asks.map((ask) => (
        <span key={ask} className={shared.chip}>
          {intl.formatMessage(ASK_TEXT[ask])}
        </span>
      )),
    [asks, intl]
  );
  if (asks.length === 0) {
    return null;
  }
  return (
    <div className={styles.asks} data-testid="reply-asks">
      <span className={shared.eyebrow}>{intl.formatMessage(messages.theyAsk)}</span>
      {chips}
    </div>
  );
};

export const ReplyAsks = TypedMemo(ReplyAsksComponent);
